<!-- TEMPLATE -->
<template>
  <div class="dropzone-container">
    <input
      type="file"
      :id="id + '-file-upload'"
      ref="fileUpload"
      @change="attachFile"
    />
    <div class="dropzone" v-if="this.file == null">
      <dean-icon class="upload-icon" :glyph="uploadIcon"></dean-icon>
      <p>Sleep bestand hier of klik voor upload</p>
    </div>
    <div class="dropzone active"  v-if="this.file != null && file.size/1024/1024 <= Number(this.maxSize)">
      <dean-icon class="upload-icon" :glyph="checkmarkIcon"></dean-icon>
      <p>{{ this.name }} van <strong>{{ (file.size/1024/1024).toFixed(2) }}Mb</strong> geselecteerd.</p>
    </div>
    <div class="dropzone warning"  v-if="this.file != null && file.size/1024/1024 > Number(this.maxSize)">
      <dean-icon class="upload-icon" :glyph="warningIcon"></dean-icon>
      <p>{{ this.name }} is <strong>{{ (file.size/1024/1024).toFixed(2) }}Mb</strong>, selecteer een bestand van maximaal <strong>{{ this.maxSize }}Mb</strong></p>
    </div>
    <dean-button
      v-if="this.file != null && file.size/1024/1024 <= Number(this.maxSize)"
      class="upload-button"
      :icon="uploadIcon"
      @click.native="submitFile"
      shadow
    >
      Uploaden
    </dean-button>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from "vue";
import { Component, Prop, Emit, Watch } from "vue-property-decorator";

import { uploadIcon, checkmarkIcon, warningIcon } from "../";

// COMPONENTS
import deanIcon from "./deanIcon.vue";
import deanButton from "./deanButton.vue";

@Component({
  components: {
    deanIcon,
    deanButton
  }
})
export default class deanInputFileDragDrop extends Vue {
  uploadIcon: object = uploadIcon;
  checkmarkIcon: object = checkmarkIcon;
  warningIcon: object = warningIcon
  fileUpload: any = {};
  file = null;
  name = "";

  // PROPS
  @Prop({ default: "" }) label!: string;
  @Prop({ default: "fileUpload" }) id!: string;
  @Prop({ default: false }) button!: boolean;
  @Prop({ default: 100 }) maxSize: string;

  attachFile() {
    this.fileUpload = this.$refs.fileUpload as HTMLElement;
    this.file = this.fileUpload.files[0];

    if (this.file != null) {
      this.name = this.file.name;
    }

    let formData = new FormData();
    formData.append("file", this.file);

    this.$emit("file-changed", formData);
  }

  submitFile() {
    let formData = new FormData();
    formData.append("file", this.file);
    this.$emit("upload", formData);
    this.fileUpload = {};
    this.file = null;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import "../scss/vars";

.dropzone-container {
  position: relative;
  padding: 10px;
  width: 100%;
  height: 100px;
  &:focus .dropzone {
    background: green;
  }

  input {
    position: absolute;
    top: 10px;
    left: 10px;
    @include calc("width", "100% - 20px");
    height: 80px;
    opacity: 0;
    z-index: 2;
    cursor: pointer;
  }

  .dropzone {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 10px;
    left: 10px;
    @include calc("width", "100% - 20px");
    height: 80px;
    border: 2px dashed var(--color-light, $color-light);
    background: var(--color-light-shade-3, $color-light-shade-3);
    color: var(--color-link, $color-link);
    fill: var(--color-link, $color-link);
    border-radius: 10px;
    z-index: 1;
    @media #{$small-only} {
      padding-left: 10px;
      justify-content: flex-start;
    }

    p {
      font-size: 15px;
    }

    .upload-icon {
      height: 15px;
      width: 15px;
    }
  }

  .active {
    color: var(--color-info-success, $color-info-success);
    fill: var(--color-info-success, $color-info-success);
    background: var(--color-info-success-bg, $color-info-success-bg);
    border: 2px dashed
      var(--color-info-success-border, $color-info-success-border);
  }

  .warning {
    color: var(--color-info-warning, $color-info-warning);
    fill: var(--color-info-warning, $color-info-warning);
    background: var(--color-info-warning-bg, $color-info-warning-bg);
    border: 2px dashed
      var(--color-info-warning-border, $color-info-warning-border);
  }

  
  .upload-button {
    position: absolute;
    @include calc("bottom", "50% - 20px");
    right: 20px;
    z-index: 3;
  }
}
</style>
